import React from 'react';

import './SectionHeader.css';

interface SectionHeaderProps {
  children: React.ReactNode;
  className?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  children,
  className = ''
}) => {
  return (
    <div className={`sectionHeader ${className}`}>
      <div className="sectionHeaderBadge"></div>
      {children}
    </div>
  );
};

export default SectionHeader;
